/**
 * Formatting utilities for fuelreqs operations
 * Pure functions - easily testable
 */
export class FuelreqsFormatters {
  /**
   * Generates element ID - already extracted but could be pure utility
   */
  static generateElementId(element: any): string {
    const serviceOrderId = element.serviceOrder?.oid ?? 0;
    const sourceId = element.sourceId ?? 0;
    return `${serviceOrderId}|${element.oid}|${sourceId}|${element.tailNumber}|${element.customerId}|${element.customerName}`;
  }

  /**
   * Gets services completed text
   */
  static getServicesCompletedText(fuelreq: any): string {
    const serviceOrder = fuelreq.serviceOrder;
    if (!serviceOrder || serviceOrder.numberOfTotalServices === 0) {
      return '0 / 0';
    }
    return `${serviceOrder.numberOfCompletedItems} / ${serviceOrder.numberOfTotalServices}`;
  }

  /**
   * Checks if service order has additional services
   */
  static hasAdditionalServices(fuelreq: any): boolean {
    return fuelreq != null && fuelreq.serviceOrder != null;
  }
}

